export default function Results() {
  const stats = [
    { value: '+28%', label: 'Revenue Visibility' },
    { value: '-34%', label: 'Manual Administrative Work' },
    { value: '+41%', label: 'Lead Conversion Efficiency' },
    { value: '+22%', label: 'Client Retention Increase' }
  ];

  return (
    <section id="results" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-16 text-center">
          Measured Outcomes
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center bg-white p-8 border border-gray-200">
              <div className="text-5xl md:text-6xl font-bold text-[#0F172A] mb-3">
                {stat.value}
              </div>
              <div className="text-sm text-gray-700 font-medium leading-snug">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
        <p className="text-xs text-gray-500 text-center max-w-3xl mx-auto">
          Results vary based on industry, scope, and implementation maturity.
        </p>
      </div>
    </section>
  );
}